import React, { useState } from "react";
// import My from "../assets/my.jpeg";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-scroll";
import { FiLinkedin } from "react-icons/fi";
import { FiGithub } from "react-icons/fi";
import { LuFileBadge } from "react-icons/lu";
import { motion, AnimatePresence } from "framer-motion";

const Home = () => {
  const [activeTooltip, setActiveTooltip] = useState(null);

  const links = [
    {
      href: "https://www.linkedin.com/in/firdosh01",
      label: "LinkedIn",
      icon: <FiLinkedin size={25} />,
    },
    {
      href: "https://github.com/Firdosh01",
      label: "GitHub",
      icon: <FiGithub size={25} />,
    },
    {
      href: "/",
      label: "Resume",
      icon: <LuFileBadge size={25} />,
    },
  ];

  return (
    <div name="home" className="w-full h-screen pb-5 md:pb-0 relative">
      <div className="flex flex-col items-center justify-between h-full max-w-screen-lg px-4 pt-32 mx-auto md:flex-row fadeInUp">
        <div className="flex flex-col justify-center gap-3 h-full ">
          <h2 className="text-3xl font-bold text-white sm:text-4xl">
            Hello, I am
          </h2>

          <h3
            className={`mt-1 text-4xl font-bold text-white sm:text-5xl typewriter`}
          >
            Firdosh Ansari
          </h3>

          <p className="max-w-[35rem] py-2 text-gray-400 fadeInUp">
            Aspiring MERN stack developer, specializing mostly in Frontend
            design and development.
          </p>
          <div className="flex gap-4">
            <div>
              <Link
                to="about"
                href="#about"
                smooth
                duration={500}
                offset={-50}
                spy={true}
                className="flex px-6 py-3 my-2 text-white rounded-md cursor-pointer bg-gradient-to-br from-[#1d0f46] via-[#140a23] to-[#1d0f46] w-fit item-center dark:bg-gradient-to-r dark:from-cyan-500 dark:to-blue-500 group select-none"
              >
                Portfolio
                <span className="duration-300 group-hover:rotate-90">
                  <MdOutlineKeyboardArrowRight size={25} className="ml-1" />
                </span>
              </Link>
            </div>

            <div className="flex items-center justify-center">
              <ul>
                <li className="flex gap-3 ml-3">
                  {links.map((link) => (
                    <div
                      key={link.label}
                      className="relative flex items-center"
                      onMouseEnter={() => setActiveTooltip(link.label)}
                      onMouseLeave={() => setActiveTooltip(null)}
                    >
                      <a
                        href={link.href}
                        target="_blank"
                        aria-label={link.label}
                        rel="noreferrer"
                        className="text-[#6330A0] cursor-pointer select-none"
                      >
                        {link.icon}
                      </a>

                      <AnimatePresence>
                        {activeTooltip === link.label && (
                          <motion.div
                            initial={{ opacity: 0, y: 5 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 5 }}
                            transition={{ duration: 0.2 }}
                            className="absolute bottom-full mb-2 !left-[-22px]"
                          >
                            <div className="relative bg-[#6330a0] text-white text-sm px-2 py-1 rounded shadow-lg whitespace-nowrap">
                              {link.label}
                              <div className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-x-4 border-x-transparent border-t-4 border-t-[#6330a0]"></div>
                            </div>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>
                  ))}
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* <div>
          <img
            src={My}
            alt="my profile"
            width={320}
            className="xsa:mt-3 rounded-2xl h-[365px] select-none object-cover brightness-90"
            loading="lazy"
          />
        </div> */}
      </div>
      <div className="absolute pointer-events-none inset-0 bg-[linear-gradient(rgba(255,255,255,.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.02)_1px,transparent_1px)] bg-[size:100px_100px] [mask-image:radial-gradient(ellipse_80%_85%_at_50%_0%,#000_70%,transparent_110%)]"></div>

      {/* <div className="absolute bottom-0 right-0 hidden md:block">
        <img src="/home.png" alt="" className="w-[800px]" />
      </div> */}

      <div className="w-[200px] h-[200px] bg-[#6330A0] blur-[160px] !absolute bottom-0 right-0 z-10"></div>
    </div>
  );
};

export default Home;
